import { __assign } from "tslib";
import { createCartExports } from './cart/wixcode.cart';
import { createCheckoutExports } from './checkout/wixcode.checkout';
import { createNavigateExports } from './navigate/wixcode.navigate';
import { createInternalExports } from './internal/wixcode.internal';
import { createCurrencyExports } from './currency/wixcode.currency';
import { createPartialOnlineStoresPublicApi } from '../online-stores/Exports/createExports';
import { createInternalOnlineStoresOnlyExports } from './internalOnlineStoresOnly/createInternalOnlineStoresOnly';
export var createWixcodeExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    var onlineStoresPublicApi = createPartialOnlineStoresPublicApi({
        context: context,
        origin: origin,
        isOnlineStoresViewerScript: false,
    });
    var ecomPlatformPublicApi = createEcomPlatformPublicApi({ context: context, origin: origin });
    return __assign(__assign(__assign({}, onlineStoresPublicApi), ecomPlatformPublicApi), { navigate: __assign(__assign({}, onlineStoresPublicApi.navigate), ecomPlatformPublicApi.navigate) });
};
export var createEcomPlatformPublicApi = function (_a) {
    var context = _a.context, origin = _a.origin;
    return ({
        cart: createCartExports({ context: context, origin: origin }),
        navigate: createNavigateExports({ context: context, origin: origin }),
        checkout: createCheckoutExports({ context: context, origin: origin }),
        currency: createCurrencyExports({ context: context }),
        __internal: createInternalExports({ context: context }),
        __internalOnlineStoresOnly: createInternalOnlineStoresOnlyExports({ context: context }),
    });
};
//# sourceMappingURL=createWixcodeExports.js.map